import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Iconify from 'src/components/iconify';
import {useNavigate} from 'react-router-dom';
import { useLocation } from 'react-router-dom';
export default function HeaderSimple() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <AppBar sx={{ boxShadow: 'none', bgcolor: 'background.default' }}>
      <Toolbar
        sx={{
          minHeight: '64px !important',
          px: 2,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} sx={{ width: 1 }}>
          <IconButton onClick={handleBackClick} size="small">
            <Iconify icon="eva:arrow-ios-back-fill" />
          </IconButton>
          
          <Typography variant="subtitle1">
            Rejeki Wondr BNI
          </Typography>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}